module.exports = __webpack_public_path__ + "static/media/CS161.c19dedc4.PNG";